module.exports = __webpack_public_path__ + "static/media/chevron-up-white.5eb65648.svg";